import moment from "moment/moment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import useSelection from "./useSelection";

interface TimeOption {
  label: string;
  value: string;
  timestamp: number | null;
  isExtended?: boolean;
}

const useTimeSelection = (initialValue = "ALL") => {
  const { t } = useTranslation("stats", { keyPrefix: "timeRangeSelection" });

  // Recomputed per mount rather than at module load, so a tab left open
  // overnight does not keep yesterday's cut-offs.
  const options: TimeOption[] = useMemo(() => {
    const now = moment();
    return [
      {
        // A rolling 24 hours, matching the mobile app's daily period. It was
        // previously a calendar day and only offered in extended mode, so
        // "what happened in the last day" was not reachable from the charts.
        label: t("day"),
        value: "DAY",
        timestamp: now.clone().subtract(1, "day").valueOf(),
      },
      {
        label: t("week"),
        value: "WEEK",
        timestamp: now.clone().subtract(1, "week").valueOf(),
      },
      {
        label: t("month"),
        value: "MONTH",
        timestamp: now.clone().subtract(1, "month").valueOf(),
      },
      {
        label: t("year"),
        value: "YEAR",
        timestamp: now.clone().subtract(1, "year").valueOf(),
      },
      {
        label: t("all"),
        value: "ALL",
        timestamp: null,
      },
    ];
  }, [t]);

  return useSelection(options, { initialValue });
};

export default useTimeSelection;
